import { actions, selectors } from '@elab/core/store/order';
import connect from '@elab/core/store/connect';

import { DeliveryAddress } from '../DeliveryAddress';

/**
 * Component is used to show delivery address informations
 *
 * @attr {string} [section-title] - The name of section es. Pick up address
 * @attr {boolean} [step-payment = false] - Different title style if you stay in payment step
 * @attr {string} order-code - Order code, is needed for loading order information
 *
 * @param {object} [deliveryAddress = {}] - Billing Address informations
 * @param {string} [cssClass] - Css class for orders delivery address
 * @param {boolean} [hasLoyalty] - Has loyalty points
 * @param {boolean} stepPayment - Different title style (true for Order components)
 *
 * HTML Structure
 *
 * <e2-order-delivery-address
 *      section-title="Delivery address"
 *      order-code= "12341234"
 * ></e2-order-delivery-address>
 */

const mapStateToProps = (state, ctx) => ({
    stepPayment: ctx.stepPayment,
    cssClass: ctx.cssClass,
    deliveryAddress: selectors.getDeliveryAddress(state),
    hasLoyalty: selectors.isOnlyLoyaltyProducts(state),
    deliveryModeIconUrl: selectors.getDeliveryModeIconUrl(state),
    eGiftCardConfigurationInfos: selectors.getEGiftCardConfigurationInfos(state),
    isPickupStore: selectors.isPickupStore(state),
    useNeighborhood: ctx.useNeighborhood,
});

const mapDispatchToEvents = (dispatch, ctx) => ({
    'load-order': () => dispatch(actions.loadOrder(ctx.orderCode, true, false, ctx.offlineOrder)),
});

export default () =>
    customElements.define(
        'e2-order-delivery-address',
        connect(mapStateToProps, mapDispatchToEvents)(DeliveryAddress),
    );
